<template>
    <article v-if="patientsList.length > 0" id="PatientCalendar__wrapper" class="calender-height">
        <FullCalendar :updatedOptions="calendarOptions" />
    </article>
</template>

<script lang="ts" src="./PatientCalendarContent.ts"></script>
